import { render } from "./NewsletterBanner.vue?vue&type=template&id=7645c4c4&scoped=true"
import script from "./NewsletterBanner.vue?vue&type=script&lang=js"
export * from "./NewsletterBanner.vue?vue&type=script&lang=js"

import "./NewsletterBanner.vue?vue&type=style&index=0&id=7645c4c4&lang=less&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7645c4c4"]])

export default __exports__